module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __limited-edu __limited-edu--custom2021 __uob-2025"
  }, [_c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "product-custom-title text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.product.meta.product_custom_title)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10"
  }, [_c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "custom": true,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper mt-15 mb-15"
  }, [(_vm.product.price) ? _c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.rewardTitleText))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("กรุณากรอกข้อมูลผู้ลงสมัครวิ่งและเลือกระยะทาง")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    staticClass: "slide-down-wrapper",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, _vm._l((_vm.rewards), function(reward, i) {
    return _c('div', {
      key: i,
      staticClass: "reward-item",
      class: {
        'reward-item-error': reward.error
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center block-heading"
    }, [_c('div', {
      staticClass: "bib-section-title"
    }, [_vm._v("ผู้สมัครวิ่งคนที่ " + _vm._s(i + 1) + "  ")])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {}, [_c('div', {
      staticClass: "col-sm-12 col-lg-6"
    }, [_c('div', {
      staticClass: "form__item--block"
    }, [_c('div', {
      staticClass: "row d-flex align-items-center runner-form-row"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-4"
    }, [_c('label', {
      staticClass: "form__label lh-1",
      attrs: {
        "for": ("name." + i)
      }
    }, [_vm._v("\n                                        ชื่อ-สกุล"), _c('br'), _c('small', [_vm._v("แสดงบน BIB ")]), _c('span', {
      staticStyle: {
        "color": "#EA2B2B"
      }
    }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward.fullName),
        expression: "reward.fullName"
      }],
      staticClass: "form__text",
      class: {
        'form__input--error': reward.errors.fullName
      },
      attrs: {
        "type": "text",
        "placeholder": "ระบุชื่อเป็นภาษาอังกฤษเท่านั้น",
        "name": ("name." + i),
        "id": ("name." + i)
      },
      domProps: {
        "value": (reward.fullName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(reward, "fullName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "small",
      staticStyle: {
        "margin-top": "-0.5rem",
        "color": "#EA2B2B"
      }
    }, [_vm._v("** ระบุชื่อเป็นภาษาอังกฤษเท่านั้น")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-6"
    }, [_c('div', {
      staticClass: "form__item--block"
    }, [_c('div', {
      staticClass: "row d-flex align-items-center runner-form-row"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-4"
    }, [_c('label', {
      staticClass: "form__label",
      attrs: {
        "for": ("tel." + i)
      }
    }, [_vm._v("\n                                        เบอร์โทร "), _c('span', {
      staticStyle: {
        "color": "#EA2B2B"
      }
    }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward.tel),
        expression: "reward.tel"
      }],
      staticClass: "form__text",
      class: {
        'form__input--error': reward.errors.tel
      },
      attrs: {
        "type": "text",
        "placeholder": "0123456789",
        "name": ("tel." + i),
        "id": ("tel." + i)
      },
      domProps: {
        "value": (reward.tel)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(reward, "tel", $event.target.value)
        }
      }
    })])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {}, [_c('div', {
      staticClass: "col-sm-12 col-lg-6"
    }, [_c('div', {
      staticClass: "form__item--block"
    }, [_c('div', {
      staticClass: "row d-flex align-items-center runner-form-row"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-4"
    }, [_c('label', {
      staticClass: "form__label",
      attrs: {
        "for": ("gender." + i)
      }
    }, [_vm._v("\n                                        เพศ "), _c('span', {
      staticStyle: {
        "color": "#EA2B2B"
      }
    }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-8"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward.gender),
        expression: "reward.gender"
      }],
      staticClass: "form__select",
      class: {
        'form__input--error': reward.errors.gender
      },
      attrs: {
        "type": "text",
        "name": ("gender." + i),
        "id": ("gender." + i)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(reward, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.genders), function(gender) {
      return _c('option', {
        key: gender.value,
        domProps: {
          "value": gender.value
        }
      }, [_vm._v("\n                                          " + _vm._s(gender.name) + "\n                                        ")])
    }), 0)])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-6"
    }, [_c('div', {
      staticClass: "form__item--block"
    }, [_c('div', {
      staticClass: "row d-flex align-items-center runner-form-row"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-4"
    }, [_c('label', {
      staticClass: "form__label",
      attrs: {
        "for": ("gender." + i)
      }
    }, [_vm._v("\n                                        ระบุระยะทาง "), _c('span', {
      staticStyle: {
        "color": "#EA2B2B"
      }
    }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-8"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward.range),
        expression: "reward.range"
      }],
      staticClass: "form__select",
      class: {
        'form__input--error': reward.errors.range
      },
      attrs: {
        "type": "text",
        "name": ("range." + i),
        "id": ("range." + i)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(reward, "range", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.ranges), function(range) {
      return _c('option', {
        key: range.value,
        domProps: {
          "value": range.value
        }
      }, [_vm._v("\n                                          " + _vm._s(range.name) + "\n                                        ")])
    }), 0)])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    })])])
  }), 0)])]), _vm._v(" "), (_vm.error.atLeastOneReward) ? _c('div', {
    staticClass: "alert alert--error",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("กรุณากรอกข้อมูลผู้สมัครวิ่งอย่างน้อย 1 คน")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "pt-15"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigChoice", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุตำแหน่ง --")]), _vm._v(" "), _vm._l((_vm.LevelOptions), function(LevelOption) {
    return _c('option', {
      key: LevelOption.text,
      domProps: {
        "value": LevelOption.description
      }
    }, [_vm._v("\n                        " + _vm._s(LevelOption.description) + "\n                      ")])
  })], 2)]), _vm._v(" "), (_vm.error.rewardConfigChoice) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุตำแหน่ง")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "pt-15"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigText),
      expression: "attributes.info.rewardConfigText"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigText", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุหน่วยงาน --")]), _vm._v(" "), _vm._l((_vm.FunctionOptions), function(FunctionOption) {
    return _c('option', {
      key: FunctionOption.text,
      domProps: {
        "value": FunctionOption.description
      }
    }, [_vm._v("\n                        " + _vm._s(FunctionOption.description) + "\n                      ")])
  })], 2)]), _vm._v(" "), (_vm.error.rewardConfigText) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุหน่วยงานของท่าน")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.pickupPoint),
      expression: "attributes.info.pickupPoint"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "pickupPoint", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุสถานที่ --")]), _vm._v(" "), _vm._l((_vm.PlaceOptions), function(PlaceOption) {
    return _c('option', {
      key: PlaceOption.name,
      domProps: {
        "value": PlaceOption.name
      }
    }, [_vm._v("\n                      " + _vm._s(PlaceOption.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), (_vm.error.pickupPoint) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุสาขาที่รับของที่ระลึก")]) : _vm._e(), _vm._v(" "), (_vm.isPlaceOptionType('select')) ? _c('div', [(_vm.selectedPlaceOption.params.optionTitle) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlaceOption.params.optionTitle) + " "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.pickupDetail),
      expression: "attributes.info.pickupDetail"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "pickupDetail", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("-- " + _vm._s(_vm.selectedPlaceOption.params.optionLabel) + " --")]), _vm._v(" "), _vm._l((_vm.selectedPlaceOption.params.optionType.items), function(item) {
    return _c('option', {
      key: item.name,
      domProps: {
        "value": item.name
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                      ")])
  })], 2)]), _vm._v(" "), (_vm.error.pickupDetail) ? _c('div', {
    staticClass: "alert alert--error"
  }, [(_vm.selectedPlaceOption.params.required) ? _c('span', [_vm._v(_vm._s(_vm.selectedPlaceOption.params.required))]) : _c('span', [_vm._v("กรุณากรอกข้อมูล")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {}, [(_vm.isPlaceOptionType('text')) ? _c('div', {}, [(_vm.selectedPlaceOption.params.optionLabel) ? _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "info_name2_text"
    }
  }, [_c('strong', [_vm._v("\n                        " + _vm._s(_vm.selectedPlaceOption.params.optionLabel) + " "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-remark"
  }, [_vm._v(_vm._s(_vm.selectedPlaceOption.params.optionNote))])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.pickupDetail),
      expression: "attributes.info.pickupDetail"
    }],
    staticClass: "form__text",
    attrs: {
      "id": "info_name2_text",
      "type": "text"
    },
    domProps: {
      "value": (_vm.attributes.info.pickupDetail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attributes.info, "pickupDetail", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error.pickupDetail) ? _c('div', {
    staticClass: "alert alert--error"
  }, [(_vm.selectedPlaceOption.params.required) ? _c('span', [_vm._v(_vm._s(_vm.selectedPlaceOption.params.required))]) : _c('span', [_vm._v("กรุณากรอกข้อมูล")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "alert alert--warning"
  }, [_vm._v("โปรดตรวจสอบข้อมูลผู้สมัครวิ่งให้ถูกต้องก่อนกดปุ่มสมัครวิ่ง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmReward.apply(null, arguments)
      }
    }
  }, [_vm._v("สมัครวิ่ง/ชำระเงิน")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center mb-20 flex justify-content-between align-items-center",
    attrs: {
      "data-v-1f20e9ef": ""
    }
  }, [_c('img', {
    staticClass: "logo-heartbeat",
    attrs: {
      "src": "/static/img/uob/logo-uob-heartbeat@2x.png",
      "srcset": "/static/img/uob/logo-uob-heartbeat@2x.png",
      "width": "130px",
      "alt": "TCFE x UOB"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/uob/logo-uob-tcfe@2x.png",
      "srcset": "/static/img/uob/logo-uob-tcfe@2x.png",
      "width": "180px",
      "alt": "TCFE x UOB"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("ระบุตำแหน่ง "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("ระบุหน่วยงานของท่าน "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("ระบุสถานที่รับ เลขประจำตัวผู้ร่วมงาน (BIB) "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-remark"
  }, [_vm._v("พนักงานสาขาจัดส่งให้ที่สาขา โปรดระบุสาขาที่รับของท่านให้ถูกต้อง")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02e35027","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/uob-run-ticket-2025.vue
// module id = 1099
// module chunks = 0